// BUDB - Buffer Polyfill for Browser Compatibility
// Fixes Solana Web3.js Buffer issues in Vite

// Simple Buffer polyfill for browser compatibility
if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = {
    from: (str: string) => new TextEncoder().encode(str),
    isBuffer: () => false,
  } as any;
}

// Export for explicit imports
export const BufferPolyfill = {
  from: (str: string) => new TextEncoder().encode(str),
  isBuffer: () => false,
};

export default BufferPolyfill;